import lazyImport from '../lib/lazyImport'

export const viewsArray = [
  { filename: 'Login', path: 'login' },
  { filename: 'Home', path: 'home' },
  { filename: 'NotFound', path: 'notfound' },
  { filename: 'Orders', path: 'orders' }, // orderList
  { filename: 'OrderConfirmations', path: 'orderConfirmations' },
  { filename: 'PendingOrders', path: 'pendingOrders' },
  // stock status
  { filename: 'StockInformation', path: 'stockInformation' },
  // stock status
  { filename: 'Deliveries', path: 'deliveries' },
  { filename: 'Invoices', path: 'invoices' },
  { filename: 'MaterialList', path: 'materialList' },
  { filename: 'Contracts', path: 'contracts' },
  { filename: 'MaterialInContracts', path: 'materialInContracts' },
  { filename: 'Substitutions/Export', path: 'exportSubstitutions' },
  { filename: 'Substitutions/Domestic', path: 'domesticSubstitutions' },
  { filename: 'ShippingCalendar', path: 'shippingCalendar' },
  { filename: 'Pivot/Contracts', path: 'contractPivot' },
  { filename: 'Pivot/Orders', path: 'orderPivot' },
  { filename: 'Pivot/Invoices', path: 'invoicePivot' },
  { filename: 'Pivot/Deliveries', path: 'deliveriesPivot' },
  { filename: 'Users', path: 'users' },
  { filename: 'Roles', path: 'roles' },
  { filename: 'Permissions', path: 'permissions' },
  { filename: 'Customers', path: 'customers' },
  { filename: 'Informing', path: 'informing' },
  { filename: 'ContentEditor', path: 'contentEditor' },
  { filename: 'ContactTemplate', path: 'contactTemplate' },
  { filename: 'ContactTemplateHistory', path: 'contactTemplateHistory' },
  // { filename: 'NewOrder', path: 'newOrder' },
  // { filename: 'OrderDetail', path: 'orders/:id' },
  { filename: 'DeliveryScheduler', path: 'deliveryScheduler' },
  { filename: 'Reports/UnshippedMaterials', path: 'unshippedMaterialsReport' },
  { filename: 'Reports/UpcomingExpiryDates', path: 'upcomingExpiryDatesReport' },
  { filename: 'Reports/MaterialSalesRateChanges', path: 'materialSalesRateChangesReport' },
  { filename: 'Reports/MaterialHandling', path: 'materialHandlingReport' },
  { filename: 'Reports/PendingOrders', path: 'pendingOrdersReport' },
  { filename: 'Reports/Forecast', path: 'forecast' },
  // NEW REPORTS 19.04.2021
  { filename: 'Reports/PendingOrdersStoreReport', path: 'pendingOrdersStoreReport' },
  { filename: 'Reports/StoreQuantityReport', path: 'storeQuantityReport' },

  { filename: 'Workflow', path: 'workflow' },
  { filename: 'ContractIncreaseReq', path: 'contractIncreaseReq' },
  { filename: 'MaterialPoolForOrder', path: 'materialPoolForOrder' },
  { filename: 'NewProductReq', path: 'newProductReq' },
  { filename: 'LimitIncreaseReq', path: 'limitIncrease' },
  { filename: 'DeviceConfigurationList', path: 'deviceConfigurationList' },
  { filename: 'ErrorMessages', path: 'errorMessages' },
  { filename: 'Antibody/ProfitCenterDefinition', path: 'profitCenterDefinition' },
  { filename: 'Antibody/DeviceDefinition', path: 'deviceDefinition' },
  { filename: 'Antibody/ContractDeviceAssignment', path: 'contractDeviceAssignment' },
  { filename: 'PLEditList', path: 'plEditList' },
  { filename: 'Antibody/AntibodyList', path: 'antibodyList' },
  { filename: 'Antibody/ConsumableGroups', path: 'consumableGroups' },
  { filename: 'Antibody/Orders', path: 'antibodyOrders' },
  { filename: 'Antibody/Orders', path: 'antibodyNewOrder' },
  { filename: 'Antibody/ContractList', path: 'contractList' },
  { filename: 'Antibody/ContractPartnerItems', path: 'contractPartnerItems' },
  { filename: 'Antibody/PrepkitList', path: 'prepkitList' },
  { filename: 'Antibody/ContractDuplicateRows', path: 'contractDuplicateRows' },
  { filename: 'SystemLogs', path: 'systemLogs' },
  { filename: 'SupportRequests', path: 'supportRequests' },
  { filename: 'SystemAPI', path: 'systemApi' },
  { filename: 'PriceList', path: 'priceList' },
  { filename: 'WebshopDoc', path: 'helpDocument' },
  { filename: 'PrivacyPolicy/ProcessingOfPersonalData', path: 'processingOfPersonalData' },
  { filename: 'ProgressPaymentAnalysis', path: 'progressPaymentAnalysis' },
  { filename: 'Reports/ProgressPaymentNotExitsReport', path: 'progressReport' },
]

export const views = viewsArray.reduce((memo, viewItem) => {
  return { ...memo, [viewItem.path]: lazyImport(viewItem.filename) }
}, {})
